import React, { useState, useEffect, useRef } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import uuid from 'react-uuid';
import { Formik } from 'formik';
import EducationForm from './EducationForm';
import WarningNotiifcation from 'components/WarningNotification';
//import ReCAPTCHA from 'react-google-recaptcha';
import { SetLoading } from "redux/actions/loadingActions";
import { connect } from 'react-redux';
import { updateMany } from 'services';
import { SetOperationSuccess } from "redux/actions/operationSuccessActions";
import { SetHasEducation } from "redux/actions/hasEducationDataActions";
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from "react-router";
import { get } from 'services';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let yup = require('yup');

const EducationFormWrapper = ({ data, user, SetLoading, SetOperationSuccess, opeationSuccess, SetHasEducation, hasEducationDataReducer }) => {
    //const [reCAPTCHA, setReCAPTCHA] = useState('');
    const [educationForm, setEducationForm] = useState([]);
    const [exampleOptionsArray, setExampleOptionsArray] = useState([]);
    const [loadForm, setLoadForm] = useState(false);
    const [empresaId, setEmpresaId] = useState(96);
    const [formContent, setFormContent] = useState({});
    const [formikSchema, setFormikSchema] = useState({});
    const [basicSchema, setBasicSchema] = useState({});
    const formRef = useRef();
    const [saveAndContinue, setSaveAndContinue] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
	
    useEffect(() => {
        (async function mounted() {
		
            setExampleOptionsArray(() => {
                return [{ value: '', label: 'Seleccione...' }, { value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]
            });
			
            if (user.esEmpleado) {
                const empresaId = await get(`Empleado/GetEmpresaIdByEmpleado/${user.persona.id}`);
                setEmpresaId(empresaId.data);
            }
			
            if (data && data.length > 0) {
                let schema = {};
                let values = {};
                let list = [];
                user.persona.personaEducacion = data;
				
                data.forEach(element => {
                    const elementId = element.id;
					
                    schema = {
                        ...schema,
                        [`school_${elementId}`]: yup.string().required("El campo es requerido"),
                        [`studyArea_${elementId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                        [`title_${elementId}`]: yup.string().typeError("El campo es numérico").test('len', 'El campo no puede ser mayor de 350 caracteres', val => !val || (val && val.toString().length <= 350)).required("El campo es requerido"),
                        [`level_${elementId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                        [`schedule_${elementId}`]: yup.string().when([`current_${elementId}`], {
                            is: true,
                            then: yup.string().required("El campo es requerido"),
                            otherwise: yup.string().notRequired(),
                          }),
                        [`yearFrom_${elementId}`]: yup.number('Debe ser numérico').test('len', 'Debes agregar solo 4 números!', val => !val || (val && val.toString().length === 4)).notRequired(),
                        [`until_${elementId}`]: yup.number('Debe ser numérico').test('len', 'Debes agregar solo 4 números!', val => !val || (val && val.toString().length === 4)).when([`current_${elementId}`], {
                            is: false,
                            then: yup.number().required("El campo es requerido"),
                            otherwise: yup.number().notRequired(),
                          }),
                        [`description_${elementId}`]: yup.string().notRequired(),
                        [`current_${elementId}`]: yup.bool(),
                    };
					
                    values = {
                        ...values,
                        [`school_${elementId}`]: element.escuela ?? '',
                        [`studyArea_${elementId}`]: element.estudioAreaId,
                        [`title_${elementId}`]: element.titulo ?? '',
                        [`level_${elementId}`]: element.estudioNivelId,
                        [`schedule_${elementId}`]: element.horarioTipoId ? element.horarioTipoId : '',
                        [`yearFrom_${elementId}`]: element.anioInicio ? element.anioInicio : '',
                        [`until_${elementId}`]: element.anioFin ? element.anioFin : '',
                        [`description_${elementId}`]: element.descripcion ? element.descripcion : '',
                        [`current_${elementId}`]: (element.actual == 0 ? false : true),
                    };
					
                    list.push({
                        id: elementId,
                        estado: element.estado,
                        isNew: false,
                    })
                });
                updateFormik(schema);
				
                setFormContent(() => {
                    return values
                });
				
                setEducationForm(() => {
                    return [
                        ...list
                    ];
                });
            }
            setLoadForm(true);
        })();
    }, []);
	
    useEffect(() => {
        if (loadForm) {
            if (data && data.length == 0) {
                onAddEducationForm();
            }
        }
    }, [loadForm]);
	
    const onSaveAndContinue = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(true);
                formRef.current.handleSubmit();
            }
        })
    }
	
    const onSave = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(false);
                formRef.current.handleSubmit();
            }
        })
    }
	
    const onExit = () => {
        history.push({
            pathname: "/education",
            state: {
                updateUserData: true
            }
        });
    }
	
    const updateFormik = (schema) => setFormikSchema(() => {
        return yup.object(schema);
    });
	
    const onAddEducationForm = () => {
        const guid = uuid();
        const oldValues = formRef.current.values;
		
        const newSchema = {
            ...basicSchema,
            [`school_${guid}`]: yup.string().required("El campo es requerido"),
            [`studyArea_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`title_${guid}`]: yup.string().test('len', 'El campo no puede ser mayor de 350 caracteres', val => !val || (val && val.toString().length <= 350)).required("El campo es requerido"),
            [`level_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`schedule_${guid}`]: yup.string().when([`current_${guid}`], {
                is: true,
                then: yup.string().required("El campo es requerido"),
                otherwise: yup.string().notRequired(),
              }),
            [`yearFrom_${guid}`]: yup.number('Debe ser numérico').test('len', 'Debes agregar solo 4 números!', val => !val || (val && val.toString().length === 4)).notRequired(),
            [`until_${guid}`]: yup.number('Debe ser numérico').test('len', 'Debes agregar solo 4 números!', val => !val || (val && val.toString().length === 4)).when([`current_${guid}`], {
                is: false,
                then: yup.number().required("El campo es requerido"),
                otherwise: yup.number().notRequired(),
              }),
            [`description_${guid}`]: yup.string().notRequired(),
            [`current_${guid}`]: yup.boolean(),
        };
		
        setBasicSchema(() => {
            return newSchema;
        });
		
        setFormContent(() => {
            return {
                ...oldValues,
                [`school_${guid}`]: '',
                [`studyArea_${guid}`]: '',
                [`title_${guid}`]: '',
                [`level_${guid}`]: '',
                [`schedule_${guid}`]: '',
                [`yearFrom_${guid}`]: '',
                [`until_${guid}`]: '',
                [`description_${guid}`]: '',
                [`current_${guid}`]: false,
            }
        });
		
        setEducationForm(() => {
            return [
                ...educationForm,
                {
                    id: guid,
                    estado: 1,
                    isNew: true,
                }
            ];
        });
		
        updateFormik(newSchema);
		
    };
    const onRemoveEducationForm = (identifier) => {
        let newSchema = basicSchema;
        const oldValues = formRef.current.values;
        const removedForm = educationForm.find(x => x.id === identifier);
		
        const schemaKeys = [`school_${identifier}`,
        `studyArea_${identifier}`,
        `title_${identifier}`,
        `level_${identifier}`,
        //`modality_${identifier}`, 
        `schedule_${identifier}`,
        `yearFrom_${identifier}`,
        `until_${identifier}`,
        `description_${identifier}`,
        `current_${identifier}`,
        ];
		
        schemaKeys.forEach(key => {
            delete newSchema[key]
            delete oldValues[key]
        });
		
        setBasicSchema(() => {
            return newSchema;
        });
		
        setFormContent(() => {
            return oldValues
        });
		
        updateFormik(newSchema);
		
        if (removedForm.isNew) {
            setEducationForm(() => {
                return [
                    ...educationForm.filter(x => x.id !== identifier)
                ]
            })
        } else {
            const index = educationForm.indexOf(removedForm);
            let updatededucationForm = educationForm;
            removedForm.estado = 0;
            updatededucationForm[index] = removedForm;
            setEducationForm(() => {
                return [
                    ...updatededucationForm
                ]
            })
        }
    };
	
    const notify = (text) => toast.warn(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
	
    const onFormSubmitted = async (form) => {
        try {
            let onCancelOperation = {
                cancelOperation: false,
                schools: []
            };
            let cancelValidations = [];
			
            let personaEducacion = [];
            educationForm.forEach(element => {
                const escuela = (element.estado === 0)
                    ? user.persona.personaEducacion.find(x => x.id === element.id)?.escuela
                    : form['school_' + element.id];
					
                const estudioAreaId = (element.estado === 0)
                    ? parseInt(user.persona.personaEducacion.find(x => x.id === element.id)?.estudioAreaId)
                    : parseInt(form['studyArea_' + element.id]);
					
                const titulo = (element.estado === 0)
                    ? user.persona.personaEducacion.find(x => x.id === element.id)?.titulo
                    : form['title_' + element.id];
					
                const descripcion = (element.estado === 0)
                    ? user.persona.personaEducacion.find(x => x.id === element.id)?.descripcion
                    : form['description_' + element.id];
					
                const estudioNivelId = (element.estado === 0)
                    ? parseInt(user.persona.personaEducacion.find(x => x.id === element.id)?.estudioNivelId)
                    : parseInt(form['level_' + element.id]);
					
                const horarioTipoIdF = (element.estado === 0)
                    ? parseInt(user.persona.personaEducacion.find(x => x.id === element.id)?.horarioTipoId)
                    : parseInt(form['schedule_' + element.id]);
					
                const anioInicio = (element.estado === 0)
                    ? parseInt(user.persona.personaEducacion.find(x => x.id === element.id)?.anioInicio)
                    : parseInt(form['yearFrom_' + element.id]);
					
                const anioFin = (element.estado === 0)
                    ? parseInt(user.persona.personaEducacion.find(x => x.id === element.id)?.anioFin)
                    : parseInt(form['until_' + element.id]);
					
					
                if (anioInicio && anioFin) {
                    if (anioInicio > anioFin) {
                        onCancelOperation.schools.push(escuela);
                        onCancelOperation.cancelOperation = true;
                    }
                }
				
                if (anioInicio < 0 || anioFin < 0) {
                    if (anioInicio < 0)
                        cancelValidations.push("El año inicio no puede ser negativo en la escuela " + escuela);
                    if (anioFin < 0)
                        cancelValidations.push("El año fin no puede ser negativo en la escuela " + escuela);
                    onCancelOperation.cancelOperation = true;
                }
				
                let dt = new Date();
                let currentYear = Number(dt.getFullYear());
				
                // if (anioInicio > currentYear || anioFin > currentYear) {
                //     if (anioInicio > currentYear) 
                //         cancelValidations.push("El año inicio no puede ser mayor al actual en la escuela " + escuela);
                //     if (anioFin > currentYear) 
                //         cancelValidations.push("El año fin no puede ser mayor al actual en la escuela " + escuela);
                //     onCancelOperation.cancelOperation = true;
                // }
				
                if (anioInicio > currentYear || anioFin < anioInicio) {
                    if (anioInicio > currentYear)
                        cancelValidations.push("El año inicio no puede ser mayor al actual en la escuela " + escuela);
                    if (anioFin < anioInicio)
                        cancelValidations.push("El año inicio no puede ser menor al año fin en la escuela " + escuela);
                    onCancelOperation.cancelOperation = true;
                }
				
                const actual = (element.estado === 0)
                    ? parseInt(user.persona.personaEducacion.find(x => x.id === element.id)?.actual)
                    : (form['current_' + element.id] === true) ? 1 : 0;
					
                const horarioTipoId = horarioTipoIdF && horarioTipoIdF > 0 ? horarioTipoIdF : null;
				
                // implementar este
                if (titulo.length > 350) {
                    cancelValidations.push("El campo de título no debe contener más de 350 caracteres.");
                    onCancelOperation.cancelOperation = true;
                }
				
                const obj = {
                    id: element.isNew ? null : element.id,
                    personaId: user.persona.id,
                    estado: element.estado,
                    titulo,
                    escuela,
                    estudioAreaId,
                    estudioNivelId,
                    horarioTipoId,
                    anioInicio,
                    anioFin,
                    descripcion,
                    actual
                };
				
                personaEducacion.push(obj);
            });
			
            if (onCancelOperation.cancelOperation) {
                cancelValidations.forEach(validation => {
                    notify(validation);
                });
                onCancelOperation.schools.forEach(school => {
                    notify('El año inicio no puede ser mayor al año fin en el centro educativo ' + school);
                });
                return;
            }
			
            setIsLoading(true);
			
            const response = await updateMany('PersonaEducacion', personaEducacion);
			
            if (response && response.data && response.data.some(x => x.estado == 1)) {
                SetHasEducation(true);
            } else {
                SetHasEducation(false);
            }
            SetOperationSuccess(opeationSuccess + 1)
			
            const route = saveAndContinue ? "/language" : "/education";
            history.push({
                pathname: route,
                state: {
                    updateUserData: true
                }
            });
			
        } catch (error) {
		
        } finally {
            setIsLoading(false);
        }
    };
	
    return (
        <>
            <ToastContainer />
            {
                isLoading &&
                <div className={'display-flex flex-direction-row flex-center'}>
                    <Spinner
                        animation="grow"
                        variant="primary"
                        className={'is-absolute center-spinner-vertically'}
                        size="lg" />
                </div>
            }
            <Card>
                <Card.Body className={'p-40'}>
                    {
                        loadForm &&
                        <div>
                            <Formik
                                innerRef={formRef}
                                validationSchema={formikSchema}
                                onSubmit={onFormSubmitted}
                                initialValues={formContent}
                                enableReinitialize={true}
                                validateOnChange={false}
                                validateOnBlur={false}
                            >
                                {({
                                    handleSubmit,
                                    handleChange,
                                    handleBlur,
                                    values,
                                    touched,
                                    isValid,
                                    errors,
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Form.Row>
                                            <Form.Group
                                                as={Col}
                                                md="12"
                                                controlId="campos_obligatorios"
                                                className="mb-25"
                                                style={{ fontSize: 18 }}>
                                                <div>
                                                    <b> Campos obligatorios * </b>
                                                </div>
                                            </Form.Group>
                                            {
                                                (educationForm.length > 0 && educationForm.filter(x => x.estado === 1).length > 0) ?
                                                    educationForm.filter(x => x.estado === 1).map((element) => {
                                                        return <EducationForm
                                                            key={element.id}
                                                            handleChange={handleChange}
                                                            errors={errors}
                                                            touched={touched}
                                                            values={values}
                                                            element={element}
                                                            removeEducationForm={onRemoveEducationForm}
                                                            options={exampleOptionsArray}
                                                            empresaId={empresaId} />
                                                    })
                                                    :
                                                    <Form.Group as={Col} md="12">
                                                        <WarningNotiifcation message='No ha agregado formularios a la sección ' enphasis='Educación' />
                                                    </Form.Group>
                                            }
                                            <Form.Group className={'display-flex flex-end'} as={Col} md="12">
                                                <Button onClick={onAddEducationForm}> Agregar </Button>
                                            </Form.Group>
                                        </Form.Row>
                                        {
                                            educationForm.length > 0 &&
                                            <Form.Group className={'display-flex space-between padding-right-0'} as={Col} md="12">
                                                {
                                                    hasEducationDataReducer
                                                        ? <Button size="medium" variant="light" onClick={onExit}> <b> Cancelar edición </b> </Button>
                                                        : <div> </div>
                                                }
                                                <div>
                                                    <Button size="medium" type="button" onClick={onSave}> <b> Guardar </b> </Button>
                                                    <Button className={'margin-left-5'} size="medium" type="button" onClick={onSaveAndContinue}> <b> Guardar y continuar </b> </Button>
                                                </div>
                                            </Form.Group>
                                        }
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    }
                </Card.Body>
            </Card>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        opeationSuccess: state.opeationSuccess,
        hasEducationDataReducer: state.hasEducationDataReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetLoading: (value) => dispatch(SetLoading(value)),
        SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
        SetHasEducation: (value) => dispatch(SetHasEducation(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EducationFormWrapper);